import { REST_ROUTES } from '@cdw-ae/routes-shared-api';

/**
 * Designations controller route constants
 *
 * Maps to @Controller('designations')
 */
export const DESIGNATIONS_ROUTES = {
  // Standard REST routes
  ROOT: REST_ROUTES.ROOT,
  GET_BY_ID: REST_ROUTES.GET_BY_ID,
  GROUPED: 'grouped',
} as const;

/**
 * Type representing all possible designation routes
 */
export type DesignationsRoute =
  (typeof DESIGNATIONS_ROUTES)[keyof typeof DESIGNATIONS_ROUTES];
